import { render, staticRenderFns } from "./HistoryAppointment.vue?vue&type=template&id=012b11f1&scoped=true"
import script from "./HistoryAppointment.vue?vue&type=script&lang=js"
export * from "./HistoryAppointment.vue?vue&type=script&lang=js"
import style0 from "./HistoryAppointment.vue?vue&type=style&index=0&id=012b11f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b11f1",
  null
  
)

export default component.exports